import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';

import moment from 'moment';
class Bill extends Component {
    handleClick(data, e) {
        //console.log(data);
        this.props.onSelect(data);
    }
	render() {
        const data = this.props.data;
		return (
			<table styleName="rwd-table">
                <tbody>
                    <tr>
                        <th>日期時間</th>
                        <th>內容</th>
                        <th>發票號碼</th>
                    </tr>
                    { data && data.map((object, index) => {
                        if(object.remark) {
                            return (
                            <tr key={object.index} onClick={this.handleClick.bind(this, object)}>
                                <td data-th="日期時間">{moment(object.create_time).format("YYYY-MM-DD HH:mm:ss")}</td>
                                <td data-th="內容">{object.remark}</td>
                                <td data-th="發票號碼">無</td>
                            </tr>);
                        }
                        else if( object.status === 'already_paid'){
                            return (
                            <tr key={object.serial_no} onClick={this.handleClick.bind(this, object)}>
                                <td data-th="日期時間">{moment(object.create_time).format("YYYY-MM-DD HH:mm:ss")}</td>
                                <td data-th="內容">{object.name}</td>
                                <td data-th="發票號碼">{object.serial_no}</td>
                            </tr>);
                        }
                        else if( object.status === 'refund'){
                            return (
                            <tr key={object.serial_no} styleName="refund">
                                <td data-th="日期時間">{moment(object.create_time).format("YYYY-MM-DD HH:mm:ss")}</td>
                                <td data-th="內容">{object.name}</td>
                                <td data-th="發票號碼">{object.serial_no}</td>
                            </tr>);
                        }
                        
                    })}
                    
                </tbody>
            </table>
		);
	}
}

export default CSSModule(Bill,css);








/** WEBPACK FOOTER **
 ** ./src/component/bill_full/index.js
 **/